import { SpacingOptions } from "@mui/system";

export type TSpacingConfig = {
  gridUnit: number;
  multipliers: Array<number>;
};

type ParceSpacing = (
  localeConfig?: TSpacingConfig,
  remoteConfig?: TSpacingConfig,
) => SpacingOptions | undefined;

export const parseSpacing: ParceSpacing = (localeConfig, remoteConfig) => {
  if (!localeConfig && !remoteConfig) return undefined;
  const gridUnit = remoteConfig?.gridUnit ?? localeConfig?.gridUnit;
  const multipliers = remoteConfig?.multipliers ?? localeConfig?.multipliers;
  if (typeof gridUnit !== "number" || !(multipliers || []).length) {
    return undefined;
  }
  return (multipliers || []).map(m => m * gridUnit);
};
